import * as React from 'react'
import ReadService from "../../service/read";
import Wait from "../wait";
import UgSpatial from "../../ug/ug_spatial";
import * as LF from "leaflet";
import Basemap from "../../ug/basemap";
import GeoServer from "../../service/geoserser";
import api from "../../service/api";
import CreateService from "../../service/create";

export default class DataCollectionPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            villages:[],
            village:0
        }

        this.loadMap = this.loadMap.bind(this)
        this.loadData = this.loadData.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.downloadSHP = this.downloadSHP.bind(this)
    }

    handleChange=(e)=>{ this.setState({[e.target.name]:e.target.value}) }


    componentDidMount() {
        this.loadMap()
        this.loadData()
    }



    downloadSHP(){
        try{
            Wait.show('Downloading...')
            CreateService.downloadSHP({
                village:this.state.village,
                project:this.props.project.id,
                stage:0
            }).then(r=>{
                Wait.dismiss()
                console.log(r.data)
            })

        }catch (e) {
            console.log(e)
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const card = {
            background: '#fff',
            borderRadius: 18,
            boxShadow: '0 2px 16px rgba(57,93,154,0.08)',
            padding: '24px 18px',
            margin: '24px auto 16px auto',
            maxWidth: 900,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 18,
            fontFamily
        };
        const label = {
            fontSize: 18,
            fontWeight: 600,
            color: '#395d9a',
            marginRight: 18,
            fontFamily
        };
        const select = {
            fontSize: 16,
            padding: '10px 18px',
            borderRadius: 8,
            border: '1px solid #bbb',
            margin: '0 18px 0 0',
            minWidth: 220,
            fontFamily
        };
        const button = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '10px 28px',
            fontWeight: 700,
            fontSize: 16,
            cursor: 'pointer',
            boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            transition: 'background 0.2s',
            fontFamily
        };
        const mapContainer = {
            width: '100%',
            minHeight: 400,
            height: '60vh',
            background: 'linear-gradient(120deg, #e3eaf2 0%, #f7f9fa 100%)',
            borderRadius: 18,
            boxShadow: '0 1px 8px rgba(57,93,154,0.07)',
            margin: '0 auto 32px auto',
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'center',
            fontFamily,
            overflow: 'hidden',
            position: 'relative',
            maxWidth: 1200
        };
        return (
            <div style={{width: '100%', minHeight: '100vh', background: '#f6f8fa', fontFamily}}>
                <div style={card}>
                    <span style={label}><span className={'fa fa-map'} style={{marginRight: 10}}/>CCRO Layers Map</span>
                    <select onChange={this.handleChange} name={'village'} style={select}>
                        <option value={undefined}>- Choose Village -</option>
                        {this.state.villages.map((d,i)=>{
                            return(<option value={d.id}>{d.name} - {d.draft}</option>)
                        })}
                    </select>
                    <button style={button} onClick={this.downloadSHP}>
                        <span className={'fa fa-download'} style={{marginRight: 8}}/>Download
                    </button>
                </div>
                <div style={mapContainer}>
                    <div style={{width: '100%', height: '100%'}} id={'ramani'}></div>
                </div>
            </div>
        )
    }


    loadMap() {
        UgSpatial.clear()
        let self = this
        let ly_labels = new LF.FeatureGroup(),
            ly_beacons = new LF.FeatureGroup(),
            ly_plots = new LF.FeatureGroup()
        let sat = Basemap.googleSat(),
            hybrid = Basemap.googleHybrid(),
            gray = Basemap.backWhite(),
            blank = LF.tileLayer('')

        let map = UgSpatial.map==null?LF.map('map', {
            layers: [sat,ly_plots, ly_labels],
            attributionControl: false,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: 'topleft'
            },
            maxZoom:10000
        }).setView([-6.085936, 35.711995], 6):UgSpatial.map


        let baseLayers = {
            'Gray':gray,
            "<span style='color: gray'>Blank</span>": blank,
            "Satellite": sat,
            "Hybrid": hybrid
        }


        /*let overlays = {
            'Village Land Use':ly_group,
            'Regional Land Use':ly_features,
            'Zonal Land Use':ly_features,
            'National Land Use':ly_features,
            'CCRO':ly_features,
            'Village Boundaries':ly_features,
            'Conceptial Diagrams':ly_features,
            'Others':ly_features
        }*/
        let filter = '1=1'
        let layername = 'layers_spatial'

        let selected = ''


        Wait.show("Loading Spatial...")
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        //console.log(r.data)
                        r.data.features.forEach(p=>{

                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    LF.marker(l.getBounds().getCenter(),{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.label,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_labels)
                                    l.setStyle({
                                        color:f.properties.status==='occupied'?'#000':'#f80',
                                        fillColor:f.properties.status==='occupied'?'#000':'#f80',
                                         fillOpacity: f.properties.status==='occupied'?0.4:0,
                                    })
                                },
                                /*coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },*/
                                weight:3,zIndex:2,

                            }).on('dblclick',e=>{


                            }).on('click', function (e) {

                                if (e.layer.feature.properties.status==="occupied"){
                                    alert('Occupied')
                                    return
                                }
                                //if (selected) {e.target.resetStyle(selected)}
                                selected = e.layer


                                let arr = self.state.selected_plots
                                let new_arr = self.state.selected_plots
                                let description = self.state.description
                                let new_desr = self.state.description

                                let id = parseInt(e.layer.feature.id.split('.')[1])
                                let claim = e.layer.feature.properties.claim_no

                                if (arr.includes(id)){
                                    new_arr = []
                                    new_desr = []
                                    arr.forEach(it=>{
                                        if (it!==id){
                                            new_arr.push(it)
                                        }
                                    })
                                    description.forEach(it=>{
                                        if (it!==claim){
                                            new_desr.push(claim)
                                        }
                                    })
                                    selected.setStyle({color: '#f80', weight:4})
                                }else{
                                    selected.setStyle({color: '#00f', weight:4})
                                    map.fitBounds(selected.getBounds())
                                    new_arr.push(id)
                                    new_desr.push(claim)
                                }

                                self.setState({
                                    selected_plots:new_arr,
                                    description:new_desr
                                })

                                selected.bringToFront()

                            })
                            myLayer.addTo(ly_plots)
                        })

                        //let myLayer = LF.geoJSON(r.data,{coordsToLatLng: function (coords) {return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();}})
                        let myLayer = LF.geoJSON(r.data)
                        try{ map.fitBounds(myLayer.getBounds())}catch (e) { }
                    }catch (e){
                        console.log(e)
                    }
        })



        Wait.show("Loading Spatial...")
        layername = 'answer'
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        //console.log(r.data)
                        r.data.features.forEach(p=>{

                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    LF.marker(l.getBounds().getCenter(),{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.claim_no,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_labels)
                                    l.setStyle({
                                        color:f.properties.status==='occupied'?'#000':'#f80',
                                        fillColor:f.properties.status==='occupied'?'#000':'#f80',
                                        fillOpacity: f.properties.status==='occupied'?0.4:0,
                                    })
                                },
                                /*coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },*/
                                weight:3,zIndex:2,

                            }).on('dblclick',e=>{


                            }).on('click', function (e) {

                                if (e.layer.feature.properties.status==="occupied"){
                                    alert('Occupied')
                                    return
                                }
                                //if (selected) {e.target.resetStyle(selected)}
                                selected = e.layer


                                let arr = self.state.selected_plots
                                let new_arr = self.state.selected_plots
                                let description = self.state.description
                                let new_desr = self.state.description

                                let id = parseInt(e.layer.feature.id.split('.')[1])
                                let claim = e.layer.feature.properties.claim_no

                                if (arr.includes(id)){
                                    new_arr = []
                                    new_desr = []
                                    arr.forEach(it=>{
                                        if (it!==id){
                                            new_arr.push(it)
                                        }
                                    })
                                    description.forEach(it=>{
                                        if (it!==claim){
                                            new_desr.push(claim)
                                        }
                                    })
                                    selected.setStyle({color: '#f80', weight:4})
                                }else{
                                    selected.setStyle({color: '#00f', weight:4})
                                    map.fitBounds(selected.getBounds())
                                    new_arr.push(id)
                                    new_desr.push(claim)
                                }

                                self.setState({
                                    selected_plots:new_arr,
                                    description:new_desr
                                })

                                selected.bringToFront()

                            })
                            myLayer.addTo(ly_plots)
                        })

                        //let myLayer = LF.geoJSON(r.data,{coordsToLatLng: function (coords) {return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();}})
                        let myLayer = LF.geoJSON(r.data)
                        try{ map.fitBounds(myLayer.getBounds())}catch (e) { }
                    }catch (e){
                        console.log(e)
                    }
        })


        let overlays = {
            'Plots':ly_plots,
            'Labels':ly_labels,
            'Beacons':ly_beacons,

        }


        UgSpatial.layers = LF.control.layers(baseLayers,overlays, {position: 'bottomleft'}).addTo(map)

        this.setState({
            selected_plots:[],
            description:[]
        })
    }

    loadData() {
        try {
            Wait.show('Fetching Data....')
            ReadService.fetchDraftData(this.props.project.id).then(r=>{
                Wait.dismiss()
                try {
                    this.setState({
                        villages:r.data.results
                    })
                }catch (e) {
                    console.log(e)
                }

            })
        }catch (e) {

        }
    }
}
